<template lang="html">
  <div class="fadeIn content-wrapper">
    <h2>
      <b>
        {{ $t('alerts.alerts') }}
      </b>
    </h2>
    <div>
      <md-tabs class="alert-tabs">
        <template v-for="tab in tabs">
          <md-tab v-bind:key="tab.sub_menu_id" :md-label="$t(tab.i18n)"  @click="currentTab = tab.vue_component">
            <component v-bind:is="tab.vue_component" :display="currentTab === tab.vue_component"/>
          </md-tab>
        </template>
      </md-tabs>
    </div>
  </div>
</template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Overview from './components/alertList/AlertList.vue';
import SensorThreshold from './components/thresholds/SensorThreshold.vue';
import WeatherStationThreshold from './components/weatherStationThreshold/WeatherStationThreshold';

export default {
  name: 'Alerts',
  extends: SecurityComponent,
  components: {
    Overview, // We set the name of "Overview" due to this was the previous name of the component in the database
    SensorThreshold,
    WeatherStationThreshold
  },
  data() {
    return {
      tabs: this.getTabs(),
      currentTab: '',
    };
  },

  methods: {
  },

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Alerts");
      this.$analytics.logEvent("web_alerts");
    }
  },

};
</script>

<style lang="scss" scoped >
.alert-tabs{
  .md-tabs-navigation, .md-tabs-container {
    background: none !important;
  }

  .md-button-content{
    text-transform: capitalize !important;
    font-weight: bold;
    font-size: 17px;
  }
  .md-tabs-content{
    background: none !important;
    .md-tabs-container{
      .md-tab{
        padding: 0;
      }
    }
  }
}
.red {
    color: red;
}

.green {
    color: green;
}

#map {
    min-height: 400px;
    height: 100%;
    margin-bottom: 20px;
}

.tab-wrapper{
  padding-bottom: 2rem;
  .control{
    width: 100%;

  }
}

.measure-container{
  .header{
    h6{
      font-weight: bold;
    }
  }
  .footer{
    display: flex;
    justify-content: space-between;
    span{
      color: #898989;
    }
  }
}
</style>
